import { useTranslation } from "react-i18next";
import { headerTriggerClassName } from "@/components/layout/header-trigger";
import { AskNexusMark } from "@/features/ask-nexus/components/AskNexusMark";
import { useAskNexusAccess } from "@/features/ask-nexus/hooks/useAskNexus";
import { useAskNexusPanel } from "@/features/ask-nexus/store/ask-nexus-panel.store";

/** Header button that opens the panel. Hidden without Ask Nexus access. */
export function AskNexusLauncher({ isCompact = false }: { isCompact?: boolean }) {
  const { t } = useTranslation();
  const { canView } = useAskNexusAccess();
  const isOpen = useAskNexusPanel((s) => s.isOpen);
  const toggleOpen = useAskNexusPanel((s) => s.toggleOpen);
  if (!canView) return null;

  const label = t("askNexus.title", "Ask Nexus");
  return (
    <button
      type="button"
      className={headerTriggerClassName({ open: isOpen, className: "gap-2" })}
      aria-label={isCompact ? label : undefined}
      aria-expanded={isOpen}
      data-testid="ask-nexus-launcher"
      onClick={toggleOpen}
    >
      <AskNexusMark className="h-[13px] w-6 shrink-0" />
      {isCompact ? null : <span>{label}</span>}
    </button>
  );
}
